/* eslint-disable @typescript-eslint/naming-convention */
'use strict';

import { SiteViewConfiguration } from './models/enums';

export const DeployParams = Object.seal({
  PRODUCT_VERSION: '1.0.28',
  // // localhost
  // BASE_URL: 'http://localhost:57913/api/',
  // NOTIFICATION_SERVICE_URL: 'http://192.168.0.27:5010/api/',
  // CACHE_CHANGES_URL: 'http://localhost:57913/api/',
  // POST_MESSAGE_ADDRESS: 'http://192.168.0.27',

  // //  betservice local
  // BASE_URL: 'http://192.168.0.27:49662/api/',
  // NOTIFICATION_SERVICE_URL: 'http://192.168.0.27:5010/api/',
  // CACHE_CHANGES_URL: 'http://192.168.0.27:6767/api/',
  // POST_MESSAGE_ADDRESS: 'http://192.168.0.27',
  // SPORTBOOK_BASE_URL: 'http://192.168.0.27:6767/api/',
  // TICKET_MENAGER_BASE_URL: 'http://192.168.0.27:32336/api/',
  // SIGNALR_BASE_URL: 'http://192.168.0.27:32336/',
  // TICKET_MENAGER_BASE_URL: 'http://192.168.0.68:42333/api/',s

  // nomad nigeria
  BASE_URL: 'http://web-api-nigeria.nomad.test/api/',
  NOTIFICATION_SERVICE_URL: '',
  CACHE_CHANGES_URL: 'http://server-cache-slave.nomad.test/api/',
  POST_MESSAGE_ADDRESS: 'http://192.168.0.56',
  SPORTBOOK_BASE_URL: 'http://server-cache-slave.nomad.test/api/',
  TICKET_MENAGER_BASE_URL: 'http://affiliate-platform-nigeria.nomad.test/api/',
  SIGNALR_BASE_URL: 'http://affiliate-platform-nigeria.nomad.test/',

    // nomad uganda
    // BASE_URL: 'http://web-api-uganda.nomad.test/api/',
    // NOTIFICATION_SERVICE_URL: '',
    // CACHE_CHANGES_URL: 'http://sport-book-cache.nomad.test/api/',
    // POST_MESSAGE_ADDRESS: 'http://192.168.0.56',
    // SPORTBOOK_BASE_URL: 'http://sport-book-cache.nomad.test/api/',
    // TICKET_MENAGER_BASE_URL: 'http://affiliate-platform-uganda.nomad.test/api/',
    // SIGNALR_BASE_URL: 'http://affiliate-platform-uganda.nomad.test/',


  //  affiliate local settings
  // BASE_URL: 'http://192.168.0.27:49662/api/',
  // NOTIFICATION_SERVICE_URL: 'http://192.168.0.27:5010/api/',
  // CACHE_CHANGES_URL: 'http://192.168.0.27:6767/api/',
  // POST_MESSAGE_ADDRESS: 'http://192.168.0.27',
  // SPORTBOOK_BASE_URL: 'http://192.168.0.27:6767/api/',
  // TICKET_MENAGER_BASE_URL: 'http://192.168.0.27:32336/api/',
  // SIGNALR_BASE_URL: 'http://192.168.0.27:32336/',
  // TICKET_MENAGER_BASE_URL: 'http://192.168.0.68:42333/api/',
  // TICKET_MENAGER_BASE_URL: 'http://192.168.0.16:32333/api/',


  // // betservice master
  // BASE_URL: 'http://192.168.0.73:47539/api/',
  // NOTIFICATION_SERVICE_URL: 'http://192.168.0.27:5010/api/',
  // CACHE_CHANGES_URL: 'http://192.168.0.73:47539/api/',
  // POST_MESSAGE_ADDRESS: 'http://192.168.0.73',
  // SPORTBOOK_BASE_URL: 'http://192.168.0.27:6768/api/',
  // TICKET_MENAGER_BASE_URL: 'http://192.168.0.56:32333/api/',
  // SIGNALR_BASE_URL: 'http://192.168.0.56:32333/',


  // // betservice UG/NG
  // BASE_URL: 'http://192.168.0.73:47600/api/',
  // NOTIFICATION_SERVICE_URL: 'http://192.168.0.27:5010/api/',
  // CACHE_CHANGES_URL: 'http://192.168.0.73:47600/api/',
  // POST_MESSAGE_ADDRESS: 'http://192.168.0.73',
  // SPORTBOOK_BASE_URL: 'http://192.168.0.27:6768/api/',
  // TICKET_MENAGER_BASE_URL: 'http://192.168.0.56:32335/api/',
  // SIGNALR_BASE_URL: 'http://192.168.0.56:32335/',

  // POstreSQL local
  // BASE_URL: 'http://192.168.0.56:4657/api/',
  // NOTIFICATION_SERVICE_URL: '',
  // CACHE_CHANGES_URL: 'http://192.168.0.27:6768/api/',
  // POST_MESSAGE_ADDRESS: 'http://192.168.0.56',
  // SPORTBOOK_BASE_URL: 'http://192.168.0.27:6768/api/',
  // TICKET_MENAGER_BASE_URL: 'http://192.168.0.56:32333/api/',
  // SIGNALR_BASE_URL: 'http://192.168.0.56:32333/',

  // // CRO local
  // BASE_URL: 'http://192.168.0.132:47534/api/',
  // NOTIFICATION_SERVICE_URL: 'http://192.168.0.132:5010/api/',
  // CACHE_CHANGES_URL: 'http://192.168.0.132:47534/api/',
  // POST_MESSAGE_ADDRESS: 'http://192.168.0.27',

  // // betservice external
  // BASE_URL: 'http://89.216.122.114:49666/api/webclient/',
  // BASE_URL_MOBILE: 'http://89.216.122.114:49666/api/mobileWeb/',
  // CACHE_CHANGES_URL: 'http://89.216.122.114:49666/api/webclient/',
  // POST_MESSAGE_ADDRESS: 'http://89.216.122.114',

  // // staging
  // BASE_URL: 'https://sport-webapi.mbet.rs:4896/api/',
  // CACHE_CHANGES_URL: 'https://sport-webapi.mbet.rs:4896/api/',
  // // //addres of website(parent of our iframe)
  // POST_MESSAGE_ADDRESS: 'https://mbase.mbet.rs:9000',

  // // staging cro
  // BASE_URL: 'https://stgwebapi.admiral.hr/api/',
  // CACHE_CHANGES_URL: 'https://stgwebapi.admiral.hr/api/',
  // // addres of website(parent of our iframe)
  // POST_MESSAGE_ADDRESS: 'https://stg.admiralbet.hr',

  // // PRODUCTION
  // BASE_URL: 'https://sport-webapi.admiralbet.rs/api/webclient/',
  // BASE_URL_MOBILE: 'https://sport-webapi.admiralbet.rs/api/mobileWeb/',
  // BASE_URL_ANDROID: 'https://sport-webapi.admiralbet.rs/api/android/',
  // CACHE_CHANGES_URL: 'https://sport-webapi.admiralbet.rs/api/webclient/',
  // // addres of website(parent of our iframe)
  // POST_MESSAGE_ADDRESS: '*',

  USE_MIN_CACHE_CHANGES: true,

  LOCAL_DEPLOY: false,
  STAGE_DEPLOY: false,



  // LOCAL
  // BETWEB_OFFICE_ID: 903,
  // MASTER
  // BETWEB_OFFICE_ID: 1277,
  // // MASTER
  // BETWEB_OFFICE_ID: 1191,
  // // Production office ID
  // BETWEB_OFFICE_ID: 138,
  // POstreSQL local
  // BETWEB_OFFICE_ID: 33,

  // UGANDA
  BETWEB_OFFICE_ID: 8,


  // LOCAL
  BETWEB_OFFICE_FOR_SPORT_ORDER_ID: 8,
  // MASTER
  // BETWEB_OFFICE_FOR_SPORT_ORDER_ID: 1277,
  // // MASTER
  // BETWEB_OFFICE_FOR_SPORT_ORDER_ID: 1191,
  // // STAGE
  //  BETWEB_OFFICE_FOR_SPORT_ORDER_ID: 138,

  // POstreSQL local
  // BETWEB_OFFICE_FOR_SPORT_ORDER_ID: 33,

  SMALL_SCREEN_WIDTH_PX: 740,
  USE_MOBILE_VIEW: true,
  IS_MAINTENANCE_BREAK: false,
  SHOW_BANNERS_ON_MOBILE_HOMEPAGE: true,
  // USE_FIXED_VALUES_FOR_TOP_MINUTE: true,
  // TOP_MINUTE_SPORT_IDS: [1],
  // TOP_MINUTE_BET_TYPE_IDS: [56, 22],
  // //list of strings different than tv live where mt is minute + '
  // TOP_MINUTE_MATCH_TIMES: ['5', '10', '15', '20', '25', '30', '35', '40', '45', '50', '55', '60', '65', '70', '75', '80', '85', '90']

  // only for sport named special (for ordering in tree)
  SPECIALS_SPORT_ID: 46,
  VIEW_CONFIGURATION: SiteViewConfiguration.UGANDA,
  TIMEFILTER_OFFSET: 9,
  CHECK_FOR_LIVE_STREAM: false,
  RELOAD_PAGE_ON_COMMUNICATION_ERROR: false,
  MY_TICKETS_COUNT: 10,
  // STAGE
  BANNER_SPORT_ID: 138,
  BANNER_REGION_ID: 1666,
  BANNER_COMPETITION_ID: 20648,
  // for all sports that are like specials - order by code and only have home team
  SPECIALS_SPORT_IDS: [46, 123],
  //chceck this here is const in enviroment is array
  HIGLIGHTED_LEAGUE_ID: 1941,


  IS_AFFILIATE_SITE: true,
  USE_SPORT_BOOK_FOR_OFFER: true

  // CRO PROD
  // BANNER_SPORT_ID: 145,
  // BANNER_REGION_ID: 1714,
  // BANNER_COMPETITION_ID: 21657
});
